import Template from './SellersView.njk';
import Marionette from "backbone.marionette";
import Xola from "../../Xola";
import { SellerCollectionView } from "../components/SellerCollectionView";
import "./SellersView.less";

export const SellersView = Marionette.View.extend({
  template: Template,
    className: "SellersView",
    events: {
        'click button': 'onCancel'
    },

    regions: {
        sellerList: '.region-seller-list'
    },

    onRender() {
        // Multiple seller accounts associated with this delegate. Show the list.
        var sellerCollectionView = new SellerCollectionView({collection: this.collection});
        this.showChildView("sellerList", sellerCollectionView);
    },

    onCancel() {
        this.trigger('seller.cancel');
    },

    onChildviewChildviewClick(childView) {
        var seller = new Xola.Model.Seller({id: childView.model.id});
        this.trigger('seller.select', seller);
    }
});




// WEBPACK FOOTER //
// ./src/js/view/pages/SellersView.js